import { Navigate, Outlet, useParams } from 'react-router-dom'
import { Navbar, Nav } from 'react-bootstrap';
import { useStateContext } from '../context/ContextProvider'
import logo from '../assets/svg/logo.svg'
import userIcon from '../assets/svg/user-ic.svg'
import plusIcon from '../assets/svg/ic-signup.svg'
import logoAbweb from '../assets/svg/abweb-logo.svg'
import { useEffect, useState } from 'react';
import axiosClient from '../../axios-client';
import Footer from '../views/footer/Footer';

export default function GestLayout() {

    const [hasLogoAbweb, setLogoAbweb] = useState(false)
    const { slug } = useParams();
    const { token } = useStateContext()

    useEffect(() => {
        appSettings()
    })

    const appSettings = () => {
        axiosClient.get('/app-settings')
            .then(({ data }) => {
                const isTure = data.data.show_abweb_logo
                setLogoAbweb(isTure == 0 ? false : true)

            })
            .catch(() => {
                setLoading(false)
            })
    }

    if (token) {
        return slug ? <Navigate to={`/${slug}`} /> : <Navigate to='/' />;
    } 

    return (
        <div id='guestLayout'>
            <Navbar className='px-2' bg='white' variant='white' expand='lg'>
                <Navbar.Brand href='/'>
                    <img className='logo' src={logo} />
                    {
                        hasLogoAbweb ? <div className='mx-auto justify-content-start align-items-center'>
                            <img width={15} src={logoAbweb} />
                            <span className="text-abweb"> by Abweb</span>
                        </div> : <></>
                    }
                </Navbar.Brand>
                <Navbar.Toggle aria-controls='basic-navbar-nav' />
                <Navbar.Collapse id='basic-navbar-nav'>
                    <Nav className='me-auto'>
                    </Nav>
                    <Navbar className='navbar-nav my-lg-0 navbar-nav-scroll'>
                        <li className='nav-item mx-1 w-100'>
                            <a className='nav-link py-1 text-start login-btn px-1 rounded-pill d-flex align-items-center text-nowrap' href='/login'>
                                <img width={38} height={38} src={userIcon} />
                                <span className='px-3'>Sign in</span>
                            </a>
                        </li>
                        <li className='nav-item d-flex mx-1 w-100'>
                            <a className='nav-link py-1 text-start login-btn rounded-pill px-1 signup-btn d-flex align-items-center text-nowrap' href='/signup'>
                                <img width={38} height={38} src={plusIcon} alt='' />
                                <span className='px-3'>Sign up</span>
                            </a>
                        </li>
                    </Navbar>
                </Navbar.Collapse>
            </Navbar>
            <Outlet />
            {!slug ? <Footer />: <></>}
        </div>
    )
}
